import clone from 'lodash/clone';
import {getClosestPoint, getIntersectCords, getMousePositionOnField} from "../../../../../../helpers/sqftHelper";
import store from "../../../../../../../../store";

export const getHorizontalLineIntersectionPoints = (mousePos, shape, lines = shape.getLines()) => {
  const mousePosOnFiled = getMousePositionOnField(mousePos.x, mousePos.y);
  const serverState = store.getState().serverState;
  const pos = shape.getPosition();

  const mousePosOnShape = {x: mousePosOnFiled.x - pos.x, y: mousePosOnFiled.y - pos.y};
  let verticalLinePoint1 = {x: -serverState.windowWidth, y: Math.round10(mousePosOnShape.y, -1)};
  let verticalLinePoint2 = {x: serverState.windowWidth, y: Math.round10(mousePosOnShape.y, -1)};
  let [intersectionXPointAndLine1, intersectionXPointAndLine2] = getClosestIntersectionPoints(
    lines, verticalLinePoint1, verticalLinePoint2, mousePosOnShape
  );

  if (intersectionXPointAndLine1 && intersectionXPointAndLine2) {
    intersectionXPointAndLine1.intersectionCords = {x: Math.round10(intersectionXPointAndLine1.intersectionCords.x, -1), y: Math.round10(mousePosOnFiled.y - pos.y, -1)};
    intersectionXPointAndLine2.intersectionCords = {x: Math.round10(intersectionXPointAndLine2.intersectionCords.x, -1), y: Math.round10(mousePosOnFiled.y - pos.y, -1)};

    return [intersectionXPointAndLine1, intersectionXPointAndLine2]
  }

  return []
}

export const getVerticalLineIntersectionPoints = (mousePos, shape,  lines = shape.getLines()) => {
  const mousePosOnFiled = getMousePositionOnField(mousePos.x, mousePos.y);
  const serverState = store.getState().serverState;
  const pos = shape.getPosition();

  const mousePosOnShape = {x: mousePosOnFiled.x - pos.x, y: mousePosOnFiled.y - pos.y};
  //let verticalLinePoint1 = {x: -serverState.windowWidth, y: mousePosOnShape.y};
  //let verticalLinePoint2 = {x: serverState.windowWidth, y: mousePosOnShape.y};

  let verticalLinePoint1 = {x: Math.round10(mousePosOnFiled.x - pos.x, -1), y: -serverState.windowHeight};
  let verticalLinePoint2 = {x: Math.round10(mousePosOnFiled.x - pos.x, -1), y: serverState.windowHeight};
  // let verticalLinePoint1 = {x: Math.ceil10(mousePosOnFiled.x - pos.x, 2), y: -serverState.windowHeight};
  // let verticalLinePoint2 = {x: Math.ceil10(mousePosOnFiled.x - pos.x, 2), y: serverState.windowHeight};

  let [intersectionPointAndLine1, intersectionPointAndLine2] = getClosestIntersectionPoints(
    lines, verticalLinePoint1, verticalLinePoint2, mousePosOnShape
  );

  if (intersectionPointAndLine1 && intersectionPointAndLine2) {
    intersectionPointAndLine1.intersectionCords = {x: Math.round10(mousePosOnFiled.x - pos.x, -1), y: Math.round10(intersectionPointAndLine1.intersectionCords.y, -1)};
    intersectionPointAndLine2.intersectionCords = {x: Math.round10(mousePosOnFiled.x - pos.x, -1), y: Math.round10(intersectionPointAndLine2.intersectionCords.y, -1)};
    // let intersectionPoint1 = {x: Math.ceil10(mousePosOnFiled.x - pos.x, 2), y: intersectionXPoint1.y};
    // let intersectionPoint2 = {x: Math.ceil10(mousePosOnFiled.x - pos.x, 2), y: intersectionXPoint2.y};

    return [intersectionPointAndLine1, intersectionPointAndLine2]
  }

  return []
}

/**
 * Return only two closest points from the array of intersectionPointsAndLines
 * @param {*} lines
 * @param {*} intersectionPoint1
 * @param {*} intersectionPoint2
 * @param {*} closestPont
 * @return {array} [{intersectionPoint, line}]
 */
export const getClosestIntersectionPoints = (lines, intersectionPoint1, intersectionPoint2, closestPont) => {
  let intersectionPointsAndLines = getIntersectionPointsAndLines(lines, intersectionPoint1, intersectionPoint2)
  if (intersectionPointsAndLines.length >= 1) {
    let intersectionPoints = intersectionPointsAndLines.map(pointAndLine => pointAndLine.intersectionCords);
    let closestPont1 = getClosestPoint(closestPont, intersectionPoints);
    let intersectionPointsAndLinesWithout1Point = intersectionPointsAndLines.filter(pointAndLine => pointAndLine.intersectionCords !== closestPont1);
    intersectionPoints = intersectionPointsAndLinesWithout1Point.map(pointAndLine => pointAndLine.intersectionCords);

    let closestPont2 = getClosestPoint(closestPont, intersectionPoints);

    return intersectionPointsAndLines.filter(pointAndLine => {
      return pointAndLine.intersectionCords === closestPont1 || pointAndLine.intersectionCords === closestPont2
    });
  }

  return intersectionPointsAndLines
}

/**
 * Return all intersectionsPointsAndLines between lines and two coords
 * @param {*} lines
 * @param {*} intersectionPoint1
 * @param {*} intersectionPoint2
 * @return {array} [{intersectionPoint, line}]
 */
export const getIntersectionPointsAndLines = (lines, intersectionPoint1, intersectionPoint2) => {
  let intersectionPoints = [];

  lines.forEach((line) => {
    let intersectionCords = getIntersectCords(
      Math.round10(line.from.x, -1), Math.round10(line.from.y, -1),
      Math.round10(line.to.x, -1), Math.round10(line.to.y, -1),
      Math.round10(intersectionPoint1.x, -1), Math.round10(intersectionPoint1.y, -1),
      Math.round10(intersectionPoint2.x, -1), Math.round10(intersectionPoint2.y, -1),
      false
    );
    if (intersectionCords) {
      intersectionPoints.push({intersectionCords, line});
    }
  });

  return intersectionPoints
}

/**
 *
 * @param circleX {int}
 * @param circleY {int}
 * @param circleRadius {int}
 * @param lineX1 {int}
 * @param lineY1 {int}
 * @param lineX2 {int}
 * @param lineY2 {int}
 * @return {null|{y1: *, x1: *, y2: *, x2: *}|{x: *, y: *}}
 */
export const getCircleLineIntersection = (circleX, circleY, circleRadius, lineX1, lineY1, lineX2, lineY2) => {
  const dx = lineX2 - lineX1;
  const dy = lineY2 - lineY1;
  const a = dx * dx + dy * dy;
  const b = 2 * (dx * (lineX1 - circleX) + dy * (lineY1 - circleY));
  const c = circleX * circleX + circleY * circleY + lineX1 * lineX1 + lineY1 * lineY1
    - 2 * (circleX * lineX1 + circleY * lineY1) - circleRadius * circleRadius;
  const delta = b * b - 4 * a * c;

  if (delta < 0) {
    return null; // no intersection
  } else if (delta === 0) {
    // the line is tangent to the circle
    const t = -b / (2 * a);
    const intersectionX = lineX1 + t * dx;
    const intersectionY = lineY1 + t * dy;
    return { x: intersectionX, y: intersectionY };
  } else {
    // the line intersects the circle at two points
    const t1 = (-b + Math.sqrt(delta)) / (2 * a);
    const t2 = (-b - Math.sqrt(delta)) / (2 * a);
    const intersection1X = lineX1 + t1 * dx;
    const intersection1Y = lineY1 + t1 * dy;
    const intersection2X = lineX1 + t2 * dx;
    const intersection2Y = lineY1 + t2 * dy;
    return { x1: intersection1X, y1: intersection1Y, x2: intersection2X, y2: intersection2Y };
  }
}

/**
 *
 // Example usage:
 /*
 const lines = [
 {from: {x: 0, y: 0}, to: {x: 100, y: 0}},    // line 1-2
 {from: {x: 100, y: 0}, to: {x: 100, y: 50}}, // line 2-3
 {from: {x: 100, y: 50}, to: {x: 50, y: 50}}, // line 3-4
 {from: {x: 50, y: 50}, to: {x: 50, y: 100}}, // line 4-5
 {from: {x: 50, y: 100}, to: {x: 0, y: 100}}, // line 5-6
 {from: {x: 0, y: 100}, to: {x: 0, y: 0}}     // line 6-1
 ];

 const intersection1 = {x: 50, y: 0};  // on line 1-2
 const intersection2 = {x: 50, y: 50}; // at vertex 4

 const result = splitShapeByIntersection(lines, [intersection1, intersection2]);
 console.log('Shape 1:', result.shape1);
 console.log('Shape 2:', result.shape2);
 * Splits a shape into two separate shapes based on intersection points
 * @param {Array} lines - Array of lines, each line has {from: {x, y}, to: {x, y}}
 * @param {Array} intersectionPoints - Array of two intersection points [{x, y}, {x, y}]
 * @returns {Object} - Object with two arrays: {shape1: [...points], shape2: [...points]}
 */
export function splitShapeByIntersection(lines, intersectionPoints) {
  if (!intersectionPoints || intersectionPoints.length !== 2) {
    throw new Error('Exactly two intersection points required');
  }

  const [int1, int2] = intersectionPoints;
  const points = extractPointsFromLines(lines);

  // Find which lines contain intersection points
  const int1Location = findPointLocation(lines, int1);
  const int2Location = findPointLocation(lines, int2);

  // Build two new shapes
  const shape1 = [];
  const shape2 = [];

  let currentShape = shape1;
  let reachedFirstIntersection = false;

  for (let i = 0; i < points.length; i++) {
    const point = points[i];
    const lineIndex = i;

    // Check if current line segment contains first intersection
    if (int1Location.lineIndex === lineIndex && !reachedFirstIntersection) {
      currentShape.push(point);

      // Add first intersection point if it's not at vertex
      if (!pointsEqual(int1, point)) {
        currentShape.push({...int1});
        shape2.push({...int1});
      }

      reachedFirstIntersection = true;
      currentShape = shape2;
      continue;
    }

    // Check if current line segment contains second intersection
    if (int2Location.lineIndex === lineIndex && reachedFirstIntersection) {
      currentShape.push(point);

      // Add second intersection point if it's not at vertex
      if (!pointsEqual(int2, point)) {
        currentShape.push({...int2});
        shape1.push({...int2});
      }

      currentShape = shape1;
      continue;
    }

    currentShape.push(point);
  }

  return [cleanDuplicatePoints(shape1), cleanDuplicatePoints(shape2)]
}

/**
 * Extracts unique points from lines array in clockwise order
 * @param {Array} lines - Array of lines
 * @returns {Array} - Array of points
 */
function extractPointsFromLines(lines) {
  const points = [];

  for (let i = 0; i < lines.length; i++) {
    points.push(clone(lines[i].from));
  }

  return points;
}

/**
 * Finds where intersection point is located (on which line segment)
 * @param {Array} lines - Array of lines
 * @param {Object} point - Intersection point {x, y}
 * @returns {Object} - Location info {lineIndex, isAtVertex, atStart}
 */
function findPointLocation(lines, point) {
  const tolerance = 0.001;

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];

    // Check if point is at line start vertex
    if (pointsEqual(point, line.from, tolerance)) {
      return {
        lineIndex: i,
        isAtVertex: true,
        atStart: true
      };
    }

    // Check if point is at line end vertex
    if (pointsEqual(point, line.to, tolerance)) {
      return {
        lineIndex: i,
        isAtVertex: true,
        atStart: false
      };
    }

    // Check if point is on line segment
    if (isPointOnLineSegment(point, line.from, line.to, tolerance)) {
      return {
        lineIndex: i,
        isAtVertex: false,
        atStart: false
      };
    }
  }

  return null;
}

/**
 * Checks if two points are equal within tolerance
 * @param {Object} p1 - First point {x, y}
 * @param {Object} p2 - Second point {x, y}
 * @param {Number} tolerance - Comparison tolerance
 * @returns {Boolean}
 */
function pointsEqual(p1, p2, tolerance = 0.001) {
  return Math.abs(p1.x - p2.x) < tolerance &&
    Math.abs(p1.y - p2.y) < tolerance;
}

/**
 * Checks if point lies on line segment
 * @param {Object} point - Point to check {x, y}
 * @param {Object} lineStart - Line start point {x, y}
 * @param {Object} lineEnd - Line end point {x, y}
 * @param {Number} tolerance - Distance tolerance
 * @returns {Boolean}
 */
export function isPointOnLineSegment(point, lineStart, lineEnd, tolerance = 0.05) {
  const d1 = distance(point, lineStart);
  const d2 = distance(point, lineEnd);
  const lineLength = distance(lineStart, lineEnd);

  return Math.abs(d1 + d2 - lineLength) < tolerance;
}

/**
 * get line on which point is placed
 * @param lines
 * @param {Object} point - Point to check {x, y}
 * @returns {Object} line
 */
export function getLineByPoint(lines, point) {
  for (const line of lines) {
    if (isPointOnLineSegment(point, line.from, line.to)) {
      return line
    }
  }

  return null
}

/**
 * Calculates distance between two points
 * @param {Object} p1 - First point {x, y}
 * @param {Object} p2 - Second point {x, y}
 * @returns {Number}
 */
function distance(p1, p2) {
  const dx = p2.x - p1.x;
  const dy = p2.y - p1.y;
  return Math.sqrt(dx * dx + dy * dy);
}

/**
 * Removes duplicate consecutive points from array
 * @param {Array} points - Array of points
 * @returns {Array} - Cleaned array
 */
function cleanDuplicatePoints(points) {
  if (points.length === 0) return points;

  const cleaned = [points[0]];

  for (let i = 1; i < points.length; i++) {
    if (!pointsEqual(points[i], cleaned[cleaned.length - 1])) {
      cleaned.push(points[i]);
    }
  }

  // Check if first and last points are duplicates
  if (cleaned.length > 1 && pointsEqual(cleaned[0], cleaned[cleaned.length - 1])) {
    cleaned.pop();
  }

  return cleaned;
}

// Clean polygon ring after a split: remove duplicates, tiny edges, and collinear mid-vertices.
// Expects an OPEN ring: [p0, p1, ..., pN-1] (без повтора первого в конце).
export function cleanPolygonPoints(
  points,
  {
    eps = 1e-3,         // numeric epsilon
    minEdge = 0.02,     // collapse edges shorter than this
    axisSnap = 0.05,    // snap near-axis runs to exact X/Y (0 = off)
    keepObjectIdentity = true,
    maxPasses = 5,
    collinearTol = 0.02, // max distance from point B to chord AC to treat as "collinear"
    tTol = 0.01         // tolerance for param t to still count B as between A and C
  } = {}
) {
  if (!points || points.length < 2) return points || [];

  const dist = (a,b) => Math.hypot(a.x - b.x, a.y - b.y);
  const almostEq = (a,b,tol = eps) => Math.abs(a - b) <= tol;
  const sameXY = (a,b,tol = eps) => almostEq(a.x,b.x,tol) && almostEq(a.y,b.y,tol);

  // signed double area (parallelogram area), |cross| / |AC| = distance from B to line AC
  function cross(a,b,c) {
    const abx = b.x - a.x, aby = b.y - a.y;
    const acx = c.x - a.x, acy = c.y - a.y;
    return abx * acy - aby * acx;
  }

  // parametric projection t of B onto AC; t in [0..1] means "between"
  function projT(a,b,c) {
    const acx = c.x - a.x, acy = c.y - a.y;
    const bax = b.x - a.x, bay = b.y - a.y;
    const len2 = Math.max(eps*eps, acx*acx + acy*acy);
    return (bax*acx + bay*acy) / len2;
  }

  function isBetweenParam(t) {
    return t >= -tTol && t <= 1 + tTol;
  }

  function maybeAxisSnap(arr) {
    if (!axisSnap) return;
    for (let i=0;i<arr.length;i++) {
      const p = arr[i];
      const prev = arr[(i-1+arr.length)%arr.length];
      const next = arr[(i+1)%arr.length];
      // vertical run -> snap X
      if (Math.abs(prev.x - p.x) <= axisSnap && Math.abs(next.x - p.x) <= axisSnap) {
        p.x = keepObjectIdentity ? prev.x : +prev.x;
      }
      // horizontal run -> snap Y
      if (Math.abs(prev.y - p.y) <= axisSnap && Math.abs(next.y - p.y) <= axisSnap) {
        p.y = keepObjectIdentity ? prev.y : +prev.y;
      }
    }
  }

  let ring = points.slice();

  // drop closing duplicate if provided
  if (ring.length >= 2 && sameXY(ring[0], ring[ring.length-1])) ring.pop();

  // consecutive dedupe (keep earlier object)
  {
    const out = [];
    for (let i=0;i<ring.length;i++) {
      const p = ring[i], last = out[out.length-1];
      if (!last || !sameXY(last, p)) out.push(p);
    }
    ring = out;
  }

  if (ring.length <= 2) return ring;

  for (let pass=0; pass<maxPasses; pass++) {
    let changed = false;

    // optional axis snap
    maybeAxisSnap(ring);

    // 1) tiny edges
    for (let i=0; i<ring.length && ring.length>2; ) {
      const prev = ring[(i-1+ring.length)%ring.length];
      const cur  = ring[i];
      if (dist(prev, cur) < minEdge) {
        if (!keepObjectIdentity) {
          prev.x = (prev.x + cur.x) * 0.5;
          prev.y = (prev.y + cur.y) * 0.5;
        }
        ring.splice(i,1);
        changed = true;
        continue;
      }
      i++;
    }
    if (ring.length <= 2) break;

    // 2) almost-collinear middles (distance-to-chord test)
    for (let i=0; i<ring.length && ring.length>2; ) {
      const a = ring[(i-1+ring.length)%ring.length];
      const b = ring[i];
      const c = ring[(i+1)%ring.length];

      const acLen = Math.max(eps, dist(a,c));
      const dLine = Math.abs(cross(a,b,c)) / acLen; // perpendicular distance from B to line AC
      const t = projT(a,b,c);

      if (dLine <= collinearTol && isBetweenParam(t)) {
        // B lies nearly on chord AC -> drop B
        ring.splice(i,1);
        changed = true;
        continue;
      }
      i++;
    }

    if (!changed) break;
  }

  // final consecutive dedupe
  {
    const out = [];
    for (let i=0;i<ring.length;i++) {
      const p = ring[i], last = out[out.length-1];
      if (!last || !sameXY(last, p)) out.push(p);
    }
    ring = out;
  }

  return ring;
}

export function getSnappedAnglePoint(from, to, snapAngleStep = 45, snapAngleEps = 5) {
  const dx = to.x - from.x;
  const dy = to.y - from.y;
  const angle = Math.atan2(dy, dx);
  const deg = (angle * 180) / Math.PI;

  const snappedDeg = Math.round(deg / snapAngleStep) * snapAngleStep;
  const diff = Math.abs(snappedDeg - deg);

  if (diff <= snapAngleEps) {
    const len = Math.sqrt(dx * dx + dy * dy);
    const rad = (snappedDeg * Math.PI) / 180;
    return {
      x: from.x + Math.cos(rad) * len,
      y: from.y + Math.sin(rad) * len,
      snapped: true,
    };
  }

  return { ...to, snapped: false };
}
